import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export async function openFile(fileId) {
  const res = await api.get(`/files/${fileId}`, { responseType: "blob" });
  const contentType = res.headers["content-type"] || "application/octet-stream";
  const blob = new Blob([res.data], { type: contentType });
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
